import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    analytics: {},
    volume: 100
  },
  getters: {
    volume: state => state.volume,
  },
  mutations: {
    setAnalytics(state, payload) {
      // state.analytics = Object.assign({}, payload)
    }
  },
  actions: {
    setVolume({ state }, volume) {
      // debugger
      // console.log(`setvolume vuex`, volume)
      state.volume = volume
    }
  },
  modules: {
  }
})
